import { MuiTheme } from "theme";
import { makeStyles } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => {
  const { dark: activeTabColor } = theme.palette.secondary;

  return {
    tabs: {
      minHeight: 42,
      flexShrink: 0,
      "& .MuiTabs-indicator": {
        backgroundColor: activeTabColor
      },
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        width: "100%"
      }
    },
    tabBar: {
      maxWidth: 650,
      alignSelf: "start",
      "& .mdc-tab": {
        fontSize: 14,
        height: 43,
        maxWidth: 180,
        padding: "0 20px",
        "& .mdc-tab__content": {
          paddingTop: 0,
          textTransform: "uppercase",
          alignItems: "center"
        }
      },
      "& .mdc-tab--active .mdc-tab__content": {
        "& .mdc-tab__text-label": {
          color: activeTabColor
        }
      },
      "& .mdc-tab--active .mdc-tab-indicator > .mdc-tab-indicator__content--underline":
        {
          backgroundColor: activeTabColor
        }
    }
  };
});
